import type { FaireProductEntity } from "../../entity_types/product";

export const p_ps6sj7pcnn: FaireProductEntity = {
  token: "p_ps6sj7pcnn",
  type: "product",
  name: '50 4x6" Thank You For Your Order Cards - White Bulk Inserts',
  brandToken: "b_e4kpbeuvwn",
  brandName: "T Marie",
  imageUrl:
    "https://cdn.faire.com/fastly/878181ee7243298411dd6cd6f6f3f09301f032d1211521ad2f2f9676623705f9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9187e218fdc2c797649c890a95fec3c5a9aac1d0494c5d88fffc92eed565a64d.jpeg",
    "https://cdn.faire.com/fastly/182e0abe99edff83c6cf3a31c6df558746a8c32ad6e6c362282b1258f76de6ab.jpeg",
    "https://cdn.faire.com/fastly/b8809bf232f5e06779bdc8f3ad8dba769b152b68755b24f224566427e251f771.jpeg",
    "https://cdn.faire.com/fastly/045087e21c800691b6300bf278047c1e8b88caf38b33ed5953336e1f52d1ddb9.jpeg",
    "https://cdn.faire.com/fastly/3513deabb3620068af1acbbf6df1a81e1787ab6254660f4534e4da800133e005.jpeg",
  ],
  priceDollars: 5.95,
  description:
    "• Each unit includes 50 postcards of the same design\n• 4x6” uncoated both sides\n• Postcards come shrink wrapped together as a set of 50\n\nThe perfect special touch for all of your orders!\n\nSometimes it’s those small personal touches that really make an impression on customers. And when it comes to unboxing an order in the mail, it’s the perfect opportunity to really wow your customers! That’s how you and create buzz and inspire loyal, long-term buyers.\n\nCustomers will love the warm message on these cards, and we leave plenty of space on the card for you to add your own personalized message or signature. Some business owners like to stamp their business info at the bottom, or add a logo sticker to the back of the cards.\n\nOur thank you cards can be shared in so many ways. Sales reps use them as notecards and send them in the mail. Some e-commerce sellers tape the cards to the inside the lid of boxes, while other businesses nestle the card into shopping bags beneath tissue paper.",
  tags: [],
  msrpDollars: 11.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:20.564Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
